var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFriendemoji5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3427 46.3754C30.5575 46.5936 23.4921 47.8902 31.8977 56.067C42.2952 66.1813 56.3134 60.2609 60.3411 50.7628C61.9277 47.022 61.0155 45.631 65.0248 46.8581C68.0071 56.037 47.3545 74.9551 29.3335 60.1549C27.1273 58.3427 21.7446 51.0531 23.3427 46.3754ZM53.3081 35.4575C52.1918 25.1419 66.1229 25.0937 65.0288 35.4246C61.4239 35.8381 61.7238 33.8675 59.1789 33.8533C56.6365 33.8389 56.899 35.7769 53.3081 35.4575ZM23.3388 35.3069C22.3404 25.3307 36.2313 24.8752 35.0626 35.5779C30.7434 35.7324 32.2013 33.7306 29.1399 33.8533C26.6701 33.952 26.8994 36.0748 23.3388 35.3069ZM88.1317 48.8412C90.9264 23.3589 71.8334 3.11951 49.7324 0.358307C23.775 -2.8848 3.09121 16.3443 0.346706 38.7731C-2.85279 64.9202 16.5634 85.5043 39.1278 88.1011C65.2703 91.1098 85.6066 71.8617 88.1317 48.8412Z",
    fill: "#F2B51E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendemoji5);
export default __webpack_public_path__ + "static/media/friendemoji5.19ffd0907a5acaa0f0f0fe1b0f4c0f28.svg";
export { ForwardRef as ReactComponent };